import React from "react"
import Switch from "../Switch/Switch"
//import I18n from "i18n-js/index.js.erb"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import ModalButtons from "../ModalButtons/ModalButtons"

export default class ModalWarningCheckboxConfirmation extends React.Component {
  constructor(props) {
    super(props)
  }
  
  render() {
   return(
     <div className="col-sm-12">
        <div className="row">
          {/* <div className="folio-items-alert" >{I18n.t('update_folio_items_alert')}</div> */}
          <div className="folio-items-alert">{this.props.alert_message}</div>
        </div>
        <br />
        <div className="row">
          <div className="form-group update-switch">
            <label >{I18n.t('proceed_alert')}</label>
            <Switch onText="yes" switchId="update-folio-items-switch" offText="no" value={this.props.overbooking_confirmation} onChange={this.props.onChangeOverbookingConfirmation} />
            <LoadingSpinner show={this.props.loading} />
          </div>
        </div>
      </div>
    );
  
  }
}